import styled from "styled-components";

export const StyledBubbleItem = styled.div`
  display: flex;
  gap: 0.2rem;
  flex-direction: column;
  &.user-bubble-container {
    align-items: flex-end;
  }

  .chatbot-button-container {
    width: 100%;
    height: 1.2rem;
    display: flex;
    align-items: center;
    gap: 0.2rem;

    &.user {
      justify-content: flex-end;
    }

    .created-at {
      font: var(--label-small-400);
      font-size: 0.8rem;
      color: var(--text-gray-4);
    }

    .chatbot-button {
      background-color: transparent;
      border: none;
      width: 1.2rem;
      height: 1.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        svg path {
          stroke: var(--pri-blue-4);
        }
      }
    }
  }
  > .bubble {
    display: flex;
    flex-direction: column;
    border-radius: 0.8rem;
    padding: 0.6rem 1rem;
    box-sizing: border-box;
    width: fit-content;
    max-width: 100%;
    font: var(--body-small-400);
    font-size: 1rem;
    line-height: 1.6rem;

    word-break: break-all;

    h1 {
      font-size: 1.6rem;
      font-weight: 600;
    }
    h2 {
      font-size: 1.4rem;
      font-weight: 600;
    }
    h3 {
      font-size: 1.2rem;
      font-weight: 600;
    }
    h4 {
      font-size: 1rem;
      font-weight: 600;
    }

    ul {
      list-style-type: disc;
      padding-inline-start: 3.2rem;
    }

    ol {
      list-style-type: decimal;
      padding-inline-start: 3.2rem;
    }

    b,
    strong {
      font-weight: 600;
    }

    blockquote {
      border-left: 0.2rem solid var(--text-gray-4);
      padding-left: 1.6rem;
      margin: 1.6rem 0;
    }

    i,
    em {
      font-style: italic;
    }

    pre {
      background-color: var(--bg-gray-1); /* 배경 색 */
      color: var(--text-gray-strong);
      border-radius: 8px; /* 모서리 둥글게 */
      padding: 16px; /* 안쪽 여백 */
      overflow-x: auto; /* 가로 스크롤 허용 */
      font-family: monospace; /* 고정폭 글꼴 */
      word-wrap: break-word; /* 긴 단어도 줄 바꿈 */
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 그림자 효과 */
      margin: 20px 0; /* 위 아래 여백 */
    }

    /* 코드 내부 텍스트 스타일 */
    code {
      color: var(--text-gray-strong); /* 글자 색 */
      font-size: 1rem; /* 글자 크기 */
      background-color: var(--bg-gray-1);
      padding: 0.4rem;
      border-radius: 0.4rem;
    }

    /* 코드 블럭에 하이라이트 추가 */
    pre code {
      background: none; /* 기본 배경 제거 */
      color: inherit; /* 상속된 색 사용 */
      padding: 0; /* 내부 여백 제거 */
      border: none; /* 테두리 제거 */
    }

    del {
      text-decoration: line-through;
    }

    &.user-bubble {
      background-color: var(--pri-blue-4);
      border-top-right-radius: 0;
      color: var(--text-gray-normal);
    }
    &.assistant-bubble,
    &.loading-message {
      background-color: var(--bg-gray-normal);
      border-top-left-radius: 0;
      border: 0.1rem solid var(--bg-gray-1);
      color: var(--text-gray-strong);
      &.error {
        color: var(--sys-red-1);
      }
      .assistant-bubble-content {
        width: fit-content;
        max-width: 100%;
      }
    }

    @keyframes loading {
      0%,
      100% {
        opacity: 0;
        transform: scale(0.5);
      }
      50% {
        opacity: 1;
        transform: scale(1.2);
      }
    }

    &.loading-message {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      height: 2.8rem;
      width: 4rem;

      > span {
        display: inline-block;
        flex-grow: 0;
        width: 0.4rem;
        height: 0.4rem;
        background-color: gray;
        border-radius: 50%;
        animation: loading 1s linear infinite;
        background-color: var(--pri-blue-4);

        &:nth-child(1) {
          animation-delay: 0s;
        }

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }
  }
`;
